import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { removeTask, saveTasksToStorage } from '../../../models/TaskModel';
import { useNotificationCount } from '../../../context/NotificationCountContext';


const DeleteTaskModal = ({showModal, setShowModal, taskData, modalKey, fetchTasks, limit, page}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

    const navigate = useNavigate(); 

    const { state } = useAuth(); 

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');

    const [loading, setLoading] = useState(false);
    
    const [task_unique_id, setTaskUniqueID] = useState('');

    const closeModal = () =>{
        setTaskUniqueID('');
        setShowModal(false);
    }

    useEffect(() => {
        // This effect will be called whenever noteData changes
        if (taskData) {
            setTaskUniqueID(taskData.task_unique_id);
        }
    }, [taskData, modalKey]);


    const deleteTask = async() => {
        // Start the loading state
        loader.style.display = 'block';
    
        try {
          const response = await removeTask(user_data.user_token, task_unique_id);
    
          if (response.status) {
            toast.success(response.message);
    
            closeModal();
    
            saveTasksToStorage(response.data.tasks, response.data.pagination);
    
            fetchTasks(limit, page); 

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          if (error.response.data.invalid_token==1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        loader.style.display = 'none';
    }

    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Task</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <p>Do you want to delete this task ? This process can't be undone</p>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={deleteTask}>Delete</button>
            </Modal.Footer>
        </Modal>
    );  

}; 


export default DeleteTaskModal;